export const THREAD_STATUS_LABELS = {
  open: 'Ouvert',
  closed: 'Fermé',
  archived: 'Archivé',
};

export const RP_STATUS_LABELS = {
  in_progress: 'En cours',
  completed: 'Terminée',
  abandoned: 'Abandonnée',
};

export const THREAD_TYPE_LABELS = {
  roleplay: 'RP',
  hrp: 'HRP',
  discussion: 'Discussion',
  announcement: 'Annonce',
  character_sheet: 'Fiche',
  normal: 'HRP',
};

export function isRoleplayThread(thread) {
  return Boolean(thread?.isRoleplay || thread?.type === 'roleplay');
}

export function getThreadModerationStatus(thread) {
  if (thread?.status) return thread.status;
  if (thread?.locked) return 'closed';
  return 'open';
}

export function getThreadRpStatus(thread) {
  if (!isRoleplayThread(thread)) return null;
  return thread?.rpStatus || 'in_progress';
}
